import p5 from "p5";
import { GameController } from "./GameController";
import { GameModel } from "./GameModel";
import { GameView } from "./GameView";
import { ViewHello } from "../views/ViewHello";

export class Game {
    public model?: GameModel;
    public controller?: GameController;
    public view?: GameView;

    constructor() {

    }

    public preload() {

    }

    public init(p: p5) {
        this.view = new GameView(p);
        this.model = new GameModel();
        this.controller = new GameController(p, this.model, this.view);
        this.controller.start();
    }

    public update(dt: number) {
        if (this.model) this.model.update(dt);
    }

    public draw() {
        if (this.controller) this.controller?.draw();
    }

}